module.exports = __webpack_public_path__ + "assets/img/something_cool.f0fdb824.svg";